import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import 'lib-flexible' // 屏幕自适应 (px -> rem)
import './assets/js/flexible.js'

Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios

import vueSeamless from 'vue-seamless-scroll'
Vue.use(vueSeamless)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/scss/element-variables.scss'
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(ElementUI);

import * as echarts from "echarts"
Vue.prototype.$echarts = echarts
import 'echarts-liquidfill'

Vue.prototype.back = function () {
  router.go(-1)
}

import htmlToPdf from '@/assets/js/pdf'
Vue.use(htmlToPdf)


import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)


import { numberToCurrencyNo, setTabNumber,dealBigNum } from "@/assets/js/utils";
// 配置全局过滤器，实现数字千分位格式
Vue.filter('numberToCurrency', numberToCurrencyNo)
// 表格千位符方法
Vue.prototype.$setTabNumber = setTabNumber
// 处理数值过万
Vue.filter('handleNumPublicFun', dealBigNum)



import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

import moment from "moment"
Vue.prototype.$moment = moment;

import _ from 'lodash'
Vue.prototype._ = _  


window.onresize = () => {
  return (() => {
    // console.log(document.body.clientWidth, document.body.clientHeight);
    // router.go(0)
  })();
};


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app')
